import React, { useEffect, useMemo, useState } from 'react';
import * as S from './styles';
import { useLazyQuery } from '@apollo/client';
import { gqlSchema } from '../../../gql/schema';
import { DatePicker, message } from 'antd';
import { StyledDatePicker } from '../styles';
import { Moment } from 'moment';
import moment from 'moment';
import { RangeValue } from 'rc-picker/lib/interface';
import { generateCSVFromAccounts } from '../../../utils/createCSV';

interface Props {
  view?: string;
}

const Assessment = (props: Props) => {

  // const compareDate = props.compareDate || new Date().toISOString();
  const today = moment();

  const defaultRange = useMemo(() => [today.clone().startOf('day'), today.clone().endOf('day')], []);
  const defaultDate = useMemo(() => today.clone().startOf('day'), []);
  let fileName = '';


  const [dateRange, setDateRange] = useState<[Moment, Moment]>([
    defaultRange[0].clone(),
    defaultRange[1].clone()
  ]);
  const [dateRangeComp1, setDateRangeComp1] = useState<Moment>(() =>
    defaultDate.clone()
  );
  const [dateRangeComp2, setDateRangeComp2] = useState<Moment>(() =>
    defaultDate.clone()
  );
  const [daysDifference, setDaysDifference] = useState<number>(0);



  // Query for 'Static' view
  const [fetchAccounts, { loading, error, data }] = useLazyQuery(
    gqlSchema.AdminDashboardSchema.query.DashboardSuperAdmin.DASHBOARD.getAllAssesment,
    {
      fetchPolicy: 'cache-first',
      onError: (err) => message.error(`Error fetching accounts: ${err.message}`),
    }
  );

  useEffect(() => {
    const [start, end] = dateRange;

    //  if (view === 'Average') {
    //    if (start?.isValid() && end?.isValid()) {
    //      fetchAvgAccounts({
    //        variables: {
    //          startDate: start.toISOString(),
    //          endDate: end.toISOString(),
    //        },
    //      });
    //    }
    //  } else
    if (props.view === 'Static') {
      if (start?.isValid() && end?.isValid()) {
        fetchAccounts({
          variables: {
            startDate: start.toISOString(),
            endDate: end.toISOString(),
            type: 'Static',
          },
        });
      }
    } else if (props.view === 'Compare') {
      if (
        dateRangeComp1?.isValid() &&
        dateRangeComp2?.isValid()

      ) {
        fetchAccounts({
          variables: {
            startDate: dateRangeComp1.toISOString(),
            endDate: dateRangeComp2.toISOString(),
            type: 'Compare',
          },
        });
      } else {
        message.warning('Please ensure both comparison dates are valid and the start date is before or equal to the end date.');
      }
    }
  }, [dateRange, dateRangeComp1, dateRangeComp2, props.view]);



  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  // Query for 'Average' view




  // Default view data (Compare view or Static view)
  const accountCardsData = props.view === 'Average'
    ? [
      { id: 1, title: 'Total Assesment', count: data?.getAllAssesment?.total1?.totalLesson1?.length || 0, type: 'total1', key: 'totalLesson1', color: '#A565A7' },
      { id: 2, title: 'Total Published', count: data?.getAllAssesment?.total1?.totalPublishedLesson1?.length || 0, type: 'total1', key: 'totalLesson1', color: '#20BC89' },
      { id: 3, title: 'Total Unpublished', count: data?.getAllAssesment?.total1?.totalUnPublishedLesson1?.length || 0, type: 'total1', key: 'totalLesson1', color: '#FFAE51' },
      { id: 4, title: 'Total Marked for Deletion', count: data?.getAllAssesment?.total1?.totalDeletedLesson1?.length || 0, type: 'total1', key: 'totalLesson1', color: '#EA3535' },

      { id: 5, title: 'Total Science', count: data?.getAllAssesment?.science1?.totalLesson1?.length || 0, type: 'total1', key: 'totalLesson1', color: '#A565A7' },
      { id: 6, title: 'Published Science', count: data?.getAllAssesment?.science1?.totalPublishedLesson1?.length || 0, type: 'total1', key: 'totalLesson1', color: '#20BC89' },
      { id: 7, title: 'Unpublished Science', count: data?.getAllAssesment?.science1?.totalUnPublishedLesson1?.length || 0, type: 'total1', key: 'totalLesson1', color: '#FFAE51' },
      { id: 8, title: 'Science Marked for Deletion', count: data?.getAllAssesment?.science1?.totalDeletedLesson1?.length || 0, type: 'total1', key: 'totalLesson1', color: '#EA3535' },

      { id: 9, title: 'Total Math', count: data?.getAllAssesment?.maths1?.totalLesson1?.length || 0, type: 'total1', key: 'totalLesson1', color: '#A565A7' },
      { id: 10, title: 'Published Math', count: data?.getAllAssesment?.maths1?.totalPublishedLesson1?.length || 0, type: 'total1', key: 'totalLesson1', color: '#20BC89' },
      { id: 11, title: 'Unpublished Math', count: data?.getAllAssesment?.maths1?.totalUnPublishedLesson1?.length || 0, type: 'total1', key: 'totalLesson1', color: '#FFAE51' },
      { id: 12, title: 'Math Marked for Deletion', count: data?.getAllAssesment?.maths1?.totalDeletedLesson1?.length || 0, type: 'total1', key: 'totalLesson1', color: '#EA3535' },
    ]

    :
    (props.view === 'Static') ? [
      { id: 1, title: 'Total Assesment', count: data?.getAllAssesment?.total1?.totalLesson1?.length || 0, type: 'total1', key: 'totalLesson1', color: '#A565A7' },
      { id: 2, title: 'Total Published', count: data?.getAllAssesment?.total1?.totalPublishedLesson1?.length || 0, type: 'total1', key: 'totalPublishedLesson1', color: '#20BC89' },
      { id: 3, title: 'Total Unpublished', count: data?.getAllAssesment?.total1?.totalUnPublishedLesson1?.length || 0, type: 'total1', key: 'totalUnPublishedLesson1', color: '#FFAE51' },
      { id: 4, title: 'Total Marked for Deletion', count: data?.getAllAssesment?.total1?.totalDeletedLesson1?.length || 0, type: 'total1', key: 'totalDeletedLesson1', color: '#EA3535' },

      { id: 1, title: 'Total Science', count: data?.getAllAssesment?.science1?.totalLesson1?.length || 0, type: 'science1', key: 'totalLesson1', color: '#A565A7' },
      { id: 2, title: 'Published Science', count: data?.getAllAssesment?.science1?.totalPublishedLesson1?.length || 0, type: 'science1', key: 'totalPublishedLesson1', color: '#20BC89' },
      { id: 3, title: 'Unpublished Science', count: data?.getAllAssesment?.science1?.totalUnPublishedLesson1?.length || 0, type: 'science1', key: 'totalUnPublishedLesson1', color: '#FFAE51' },
      { id: 4, title: 'Science Marked for Deletion', count: data?.getAllAssesment?.science1?.totalDeletedLesson1?.length || 0, type: 'science1', key: 'totalDeletedLesson1', color: '#EA3535' },

      { id: 1, title: 'Total Math', count: data?.getAllAssesment?.maths1?.totalLesson1?.length || 0, type: 'maths1', key: 'totalLesson1', color: '#A565A7' },
      { id: 2, title: 'Published Math', count: data?.getAllAssesment?.maths1?.totalPublishedLesson1?.length || 0, type: 'maths1', key: 'totalPublishedLesson1', color: '#20BC89' },
      { id: 3, title: 'Unpublished Math', count: data?.getAllAssesment?.maths1?.totalUnPublishedLesson1?.length || 0, type: 'maths1', key: 'totalUnPublishedLesson1', color: '#FFAE51' },
      { id: 4, title: 'Math Marked for Deletion', count: data?.getAllAssesment?.maths1?.totalDeletedLesson1?.length || 0, type: 'maths1', key: 'totalDeletedLesson1', color: '#EA3535' },

    ]
      :
      [
        { id: 1, title: 'Total Assesment', count: data?.getAllAssesment?.total1?.totalLesson1?.length || 0, type: 'total1', key: 'totalLesson1', color: '#A565A7' },
        { id: 2, title: 'Total Published', count: data?.getAllAssesment?.total1?.totalPublishedLesson1?.length || 0, type: 'total1', key: 'totalPublishedLesson1', color: '#20BC89' },
        { id: 3, title: 'Total Unpublished', count: data?.getAllAssesment?.total1?.totalUnPublishedLesson1?.length || 0, type: 'total1', key: 'totalUnPublishedLesson1', color: '#FFAE51' },
        { id: 4, title: 'Total Marked for Deletion', count: data?.getAllAssesment?.total1?.totalDeletedLesson1?.length || 0, type: 'total1', key: 'totalDeletedLesson1', color: '#EA3535' },

        { id: 1, title: 'Total Science', count: data?.getAllAssesment?.science1?.totalLesson1?.length || 0, type: 'science1', key: 'totalLesson1', color: '#A565A7' },
        { id: 2, title: 'Published Science', count: data?.getAllAssesment?.science1?.totalPublishedLesson1?.length || 0, type: 'science1', key: 'totalPublishedLesson1', color: '#20BC89' },
        { id: 3, title: 'Unpublished Science', count: data?.getAllAssesment?.science1?.totalUnPublishedLesson1?.length || 0, type: 'science1', key: 'totalUnPublishedLesson1', color: '#FFAE51' },
        { id: 4, title: 'Science Marked for Deletion', count: data?.getAllAssesment?.science1?.totalDeletedLesson1?.length || 0, type: 'science1', key: 'totalDeletedLesson1', color: '#EA3535' },

        { id: 1, title: 'Total Math', count: data?.getAllAssesment?.maths1?.totalLesson1?.length || 0, type: 'maths1', key: 'totalLesson1', color: '#A565A7' },
        { id: 2, title: 'Published Math', count: data?.getAllAssesment?.maths1?.totalPublishedLesson1?.length || 0, type: 'maths1', key: 'totalPublishedLesson1', color: '#20BC89' },
        { id: 3, title: 'Unpublished Math', count: data?.getAllAssesment?.maths1?.totalUnPublishedLesson1?.length || 0, type: 'maths1', key: 'totalUnPublishedLesson1', color: '#FFAE51' },
        { id: 4, title: 'Math Marked for Deletion', count: data?.getAllAssesment?.maths1?.totalDeletedLesson1?.length || 0, type: 'maths1', key: 'totalDeletedLesson1', color: '#EA3535' },

        { id: 5, title: 'Total Assesment', count: data?.getAllAssesment?.total2?.totalLesson1?.length || 0, type: 'total2', key: 'totalLesson2', color: '#A565A7' },
        { id: 6, title: 'Total Published', count: data?.getAllAssesment?.total2?.totalPublishedLesson1?.length || 0, type: 'total2', key: 'totalPublishedLesson2', color: '#20BC89' },
        { id: 7, title: 'Total Unpublished', count: data?.getAllAssesment?.total2?.totalUnPublishedLesson1?.length || 0, type: 'total2', key: 'totalUnPublishedLesson2', color: '#FFAE51' },
        { id: 8, title: 'Total Marked for Deletion', count: data?.getAllAssesment?.total2?.totalDeletedLesson1?.length || 0, type: 'total2', key: 'totalDeletedLesson2', color: '#EA3535' },

        { id: 5, title: 'Total Science', count: data?.getAllAssesment?.science2?.totalLesson1?.length || 0, type: 'science2', key: 'totalLesson1', color: '#A565A7' },
        { id: 6, title: 'Published Science', count: data?.getAllAssesment?.science2?.totalPublishedLesson1?.length || 0, type: 'science2', key: 'totalPublishedLesson2', color: '#20BC89' },
        { id: 7, title: 'Unpublished Science', count: data?.getAllAssesment?.science2?.totalUnPublishedLesson1?.length || 0, type: 'science2', key: 'totalUnPublishedLesson2', color: '#FFAE51' },
        { id: 8, title: 'Science Marked for Deletion', count: data?.getAllAssesment?.science2?.totalDeletedLesson1?.length || 0, type: 'science2', key: 'totalDeletedLesson2', color: '#EA3535' },

        { id: 5, title: 'Total Math', count: data?.getAllAssesment?.maths2?.totalLesson1?.length || 0, type: 'maths2', key: 'totalLesson1', color: '#A565A7' },
        { id: 6, title: 'Published Math', count: data?.getAllAssesment?.maths2?.totalPublishedLesson1?.length || 0, type: 'maths2', key: 'totalPublishedLesson2', color: '#20BC89' },
        { id: 7, title: 'Unpublished Math', count: data?.getAllAssesment?.maths2?.totalUnPublishedLesson1?.length || 0, type: 'maths2', key: 'totalUnPublishedLesson2', color: '#FFAE51' },
        { id: 8, title: 'Math Marked for Deletion', count: data?.getAllAssesment?.maths2?.totalDeletedLesson1?.length || 0, type: 'maths2', key: 'totalDeletedLesson2', color: '#EA3535' },



      ]
    ;

  const handleDownload = (type?: string, id?: number) => {
    let sample: any[] = [];
    console.log("Tyr", type, id);


    const keyMap: Record<number, string> = {
      1: 'totalLesson1',
      2: 'totalPublishedLesson1',
      3: 'totalUnPublishedLesson1',
      4: 'totalDeletedLesson1',
      5: 'totalLesson2',
      6: 'totalPublishedLesson2',
      7: 'totalUnPublishedLesson2',
      8: 'totalDeletedLesson2',
    };

    if (!type || !id) {
      console.warn("Missing type or id for download.");
      return;
    }

    const key = keyMap[id];
    sample = data?.getAllAssesment?.[type]?.[key] ?? [];
    fileName = key;

    console.log("Downloading CSV for:", type, "with key:", key, sample);
    generateCSVFromAccounts(sample, fileName);
  };


  const handleRangeChange = (dates: RangeValue<Moment>, _dateStrings: [string, string]) => {
    if (dates && dates[0] && dates[1]) {
      setDateRange([dates[0], dates[1]]);
      setDaysDifference(dates[1].diff(dates[0], 'days') + 1);
    }
  };

  const handleRangeChangeComp1 = (date: Moment | null, _dateString: string) => {
    if (!date) return;

    setDateRangeComp1(date);
  };

  const handleRangeChangeComp2 = (date: Moment | null, _dateString: string) => {
    if (!date) return;

    setDateRangeComp2(date);
  };
  console.log("Ass", daysDifference);
  console.log("Data", data);

  // Reusable render block for cards and chart
  const renderCardsAndChart = (cardData: typeof accountCardsData) => (
    <>
      <S.TopRow>
        <S.DateLabel>Show:</S.DateLabel>
        <StyledDatePicker
          style={{ border: '2px solid #767676', borderRadius: '16px' }}
          value={dateRange}
          onChange={handleRangeChange}
          allowClear={false}
        />
      </S.TopRow>
      <S.CardGrid>
        {cardData.map((card) => {

          return (
            <S.Card key={card.title} color={card.color}>


              <S.CardTitle>{card.title}</S.CardTitle>
              <S.CardCount>{card.count}</S.CardCount>

              <S.DownloadButton fontColor={card.color} onClick={() => handleDownload(card.type, card.id)}>
                Download
              </S.DownloadButton>
            </S.Card>
          );
        })}
      </S.CardGrid>
    </>

  );
  const renderCardsAndChartComp = (cardData: typeof accountCardsData) => (
    <>
      <S.TopRow>
        <S.DateLabel>Show:</S.DateLabel>
        <DatePicker
          style={{ border: '2px solid #767676', borderRadius: '10px' }}
          value={dateRangeComp1}
          onChange={handleRangeChangeComp1}
          allowClear={false}
        />
      </S.TopRow>
      <S.CardGrid>
        {cardData?.slice(0, 12).map((card) => {


          // const handleVisibilityToggle = () => {
          //   setVisibilityMap((prev) => ({
          //     ...prev,
          //     [card.title]: !isVisible,
          //   }));
          // };

          return (
            <S.Card key={card.title} color={card.color}>


              <S.CardTitle>{card.title}</S.CardTitle>
              <S.CardCount>{card.count}</S.CardCount>

              <S.DownloadButton fontColor={card.color} onClick={() => console.log(`Download data for ${card.title}`)}>
                Download
              </S.DownloadButton>
            </S.Card>
          );
        })}
      </S.CardGrid>
      <S.TopRow>
        <S.DateLabel>Show:</S.DateLabel>
        <DatePicker
          style={{ border: '2px solid #767676', borderRadius: '10px' }}
          value={dateRangeComp2}
          onChange={handleRangeChangeComp2}
          allowClear={false}
        />
      </S.TopRow>
      <S.CardGrid>
        {cardData?.slice(12, 32).map((card) => {

          return (
            <S.Card key={card.title} color={card.color}>


              <S.CardTitle>{card.title}</S.CardTitle>
              <S.CardCount>{card.count}</S.CardCount>

              <S.DownloadButton fontColor={card.color} onClick={() => console.log(`Download data for ${card.title}`)}>
                Download
              </S.DownloadButton>
            </S.Card>
          );
        })}
      </S.CardGrid>
    </>

  );




  return (
    <>
      {/* Static/Compare View Layout */}
      {props.view === 'Compare' && (
        <div style={{ marginBottom: '40px' }}>
          <h3>Compare View</h3>
          {renderCardsAndChartComp(accountCardsData)}
        </div>
      )}

      {/* Average View Layout */}
      {props.view === 'Average' && (
        <div style={{ marginBottom: '40px' }}>
          <h3>Average View</h3>
          {renderCardsAndChart(accountCardsData)}
        </div>
      )}

      {/* Static View Layout */}
      {props.view === 'Static' && (
        <div style={{ marginBottom: '40px' }}>
          <h3>Static View</h3>
          {renderCardsAndChart(accountCardsData)}
        </div>
      )}

    </>
  );
};
export default Assessment;
